import {environment} from '../../environments/environment';

export class NICEApiHelper
{
    aacLicenseUrl = ''; // populated from environment file
    aacAwsUrl = ''; // populated from environment file
    aacUtilityUrl = ''; // populated from environment file
    aacSkyDataUrl = ''; // populated from environment file

    apiAcdUrl = '';
    apiBaseUrl = '';
    notificationUrl: string;
    wfmUrl: string;
    scheduleAPIRUL: string;

    apiVersion = 'v22.0';
    domainPrefix: string;

    cluster: string;
    businessUnit: number;
    businessUnitType: string;
    agentId: number;
    uhDomain= '';
    acdDomain = '';
    private standardDomain: any;

    constructor()
    {
        const licenseUrl = environment.aacLicenseUrl;
        const awsUrl = environment.aacAwsUrl;
        const utilityUrl = environment.aacUtilityUrl;
        const skyDataUrl = environment.aacSkyDataUrl;

        this.aacLicenseUrl = licenseUrl;
        this.aacAwsUrl = awsUrl;
        this.aacUtilityUrl = utilityUrl;
        this.aacSkyDataUrl = skyDataUrl;
    }

    get acdEndpoint(){
        return 'https://home-' + this.cluster  + '.' + this.acdDomain + '/';
    }

    get digitalUIEndpoint(){
        return 'https://app-de-'+ this.domainPrefix  + '.' + this.standardDomain + '/';
    }

    get acdRedirectURL()
    {
        return 'https://'+this.domainPrefix+'.'+ this.uhDomain +'/login/#/?redirectURL='
    }

    get uhEndpoint(){
        return 'https://home-' + this.cluster  + '.' + this.uhDomain + '/';
    }

    setAuthDataByDiscovery(disResponse: any,tokenData: any) {
        this.businessUnit = tokenData.icBUId;
        this.agentId = tokenData.icAgentId;
        this.apiAcdUrl = disResponse.api_endpoint+'/inContactAPI/';
        this.apiBaseUrl = disResponse.api_endpoint +'/';
        this.domainPrefix = disResponse.area;
        this.wfmUrl = disResponse.api_endpoint+'/inContactAPI/';
        this.uhDomain = disResponse.uhDomain;
        this.acdDomain = disResponse.acdDomain;
        this.cluster = disResponse.cluster;
        this.scheduleAPIRUL = 'https://api-' + this.cluster.toLowerCase() +'.' + disResponse.acdDomain + '/incontactapi/';
        this.standardDomain = disResponse.domain;
    }
}
